import { createStore } from 'vuex'
import { setItem, getItem } from '@/utils/storage.js'
export default createStore({
  state: {
    token: getItem('token') || '',
    ExhCode: getItem('ExhCode') || '24jzgslblh',
    VisitorID: getItem('VisitorID') || '',
    loginForm: getItem('loginForm') || '',
    isPC: getItem('isPC') || false,
    mainColor: getItem('mainColor') || false,
    openid: getItem('openid') || '',
    isWeX: getItem('isWeX') || '',
    isMini: getItem('isMini') || '',
    gconfig: getItem('gconfig') || ''
  },
  mutations: {
    setToken(state, payLoad) {
      state.token = payLoad
      setItem('token', payLoad)
    },
    setExhCode(state, payLoad) {
      state.ExhCode = payLoad
      setItem('ExhCode', payLoad)
    },
    setVisitorID(state, payLoad) {
      state.VisitorID = payLoad
      setItem('VisitorID', payLoad)
    },
    setLoginForm(state, payLoad) {
      state.loginForm = payLoad
      setItem('loginForm', payLoad)
    },
    setIsPC(state, payLoad) {
      state.isPC = payLoad
      setItem('isPC', payLoad)
    },
    setOpenID(state, payLoad) {
      state.openid = payLoad
      setItem('openid', payLoad)
    },
    setIsWeX(state, payLoad) {
      state.isWeX = payLoad
      setItem('isWeX', payLoad)
    },
    setIsMini(state, payLoad) {
      state.isMini = payLoad
      setItem('isMini', payLoad)
    },
    setGConfig(state, payLoad) {
      state.gconfig = payLoad
      setItem('gconfig', payLoad)
    },
    setMainColor(state, payLoad) {
      state.mainColor = payLoad
      setItem('mainColor', payLoad)
    }
  },
  actions: {},
  modules: {}
})
